// extracted by mini-css-extract-plugin
export default {"leavesView":"Leaves_leavesView__lXM82","card":"Leaves_card__2mNcu"};